import api from "./axios";
import { paths } from "./paths";

const apiRoot = `${process.env.API_URL || ""}/api`;

export function getGoogleAuthUrl(): string {
  return `${apiRoot}${paths.auth.google}`;
}

export function fetchMe() {
  return api.get(paths.users.me).then((r) => r.data);
}

export function logout() {
  return api.post(paths.auth.logout).then((r) => r.data);
}

export function deleteAccount() {
  return api.delete(paths.auth.me).then((r) => r.data);
}
